import { Table } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import iconTop1 from "../../../../assets/images/event-2024/icon-top-1.png";
import iconTop2 from "../../../../assets/images/event-2024/icon-top-2.png";
import iconTop3 from "../../../../assets/images/event-2024/icon-top-3.png";
import "./index.scss";
import iconMyRank from "../../../../assets/images/event-2024/My Rank.png";
import iconTitle from "../../../../assets/images/event-2024/Rank Table.png";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getRankNewYear2024 } from "dataLayer/user";
import { ID_RANK_TABLE_EVENT_2024 } from "@config/constants/helper";
import Snow from "../Components/animtion/Snow";

const totalTableRankLimit = 10;
export default function RankTable() {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("event_2024.rank-table.rank"),
      dataIndex: "key",
      key: "key",
      className: "number-column",
      render: (text) => {
        switch (+text + 1) {
          case 1:
            return <img src={iconTop1} alt="top-1" style={{minWidth: "32px"}}/>;
          case 2:
            return (
              <img src={iconTop2} alt="top-2" style={{ minWidth: "32px" }} />
            );
          case 3:
            return (
              <img src={iconTop3} alt="top-3" style={{ minWidth: "32px" }} />
            );

          default:
            return <div>{text + 1}</div>;
        }
      },
    },
    {
      title: t("event_2024.rank-table.isdn"),
      dataIndex: "isdn",
      key: "isdn",
      render: (text) => <div>{text}</div>,
    },
    {
      title: t("event_2024.rank-table.number_of_matches"),
      dataIndex: "spark",
      key: "spark",
      render: (text) => <div>{text}</div>,
    },

    {
      title: t("event_2024.rank-table.number_of_firework_shells"),
      dataIndex: "shell",
      key: "shell",
      render: (text) => <div>{text}</div>,
    },

    {
      title: t("event_2024.rank-table.number_of_firework_shows"),
      dataIndex: "firework",
      key: "firework",
      render: (text) => <div>{text}</div>,
    },
    {
      title: t("event_2024.rank-table.time_of_last_firework_shows"),
      dataIndex: "paired_time",
      key: "paired_time",
      render: (_, record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        if(!_) return(<div></div>)
        return (
          <div className="item-rank-timer">
            <span>{datePart}</span>
            <span className="time-hours-event">{timePart}</span>
          </div>
        );
      },
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleTableChange = (pagination) => {
    setPage(pagination);
    scrollToTop();
  };

  const [page, setPage] = useState(1);
  const { data: dataRank = {}, isLoading } = useQuery(
    getRankNewYear2024(page, totalTableRankLimit, ID_RANK_TABLE_EVENT_2024.myRank)
  );

  const { myRank = {}, ranks = {} } = dataRank;

  const formatDataTable = (data = []) => {
    return data.map((item, index) => {
      const date = item?.paired_time;
      
      return {
        ...item,
        key:
          item?.id === myRank?.id
            ? myRank?.position - 1
            : totalTableRankLimit * (page - 1) + index,
        updated_at: {
          day: item?.paired_time ? moment(date).format("DD/MM/YYYY") : "",
          hours: item?.paired_time ? moment(date).format("HH:mm:ss") : "",
        },
      };
    });
  };
  const dataSourceMyRank = formatDataTable([myRank]);

  return (
    <div id="rank-table">
      <Snow />
      <div className="icon-title-event">
        <img src={iconTitle} alt="" className="img-title-navidad" />
      </div>
      <div className="container-my-ranking">
        <Table
          dataSource={ranks?.data || []}
          columns={columns}
          pagination={
            ranks?.total > totalTableRankLimit
              ? {
                  current: page,
                  pageSize: totalTableRankLimit,
                  total: ranks?.total || 0,
                  onChange: handleTableChange,
                  showSizeChanger: false,
                }
              : false
          }
          rowClassName={(record) => {
            return myRank?.id === record?.id ? "my-rank-active" : "";
          }}
          className={`custom-table custom-table-ranking`}
        />
        {!myRank ? null : (
          <div
            className="my-rank-detail"
            style={{
              marginTop: `${ranks?.total < totalTableRankLimit ? "80px" : ""}`,
            }}
          >
            <div className="title-my-rank">
              <img src={iconMyRank} alt="" />
            </div>
            <Table
              dataSource={dataSourceMyRank}
              columns={columns}
              pagination={false}
              className="custom-table-ranking"
              rowClassName="my-rank-active"
            />
          </div>
        )}
      </div>
    </div>
  );
}
